import { Link, useNavigate, useParams, useLoaderData } from "react-router-dom";
import { useState } from "react";
import Select from "react-select";

import { AntmedicosUpdate } from "./AntmedicosUpdate";
import { AntmedicosDelete } from "./AntmedicosDelete";

export function AntmedicosEdit(props) {
  const antmedicos = useLoaderData();
  const navigate = useNavigate();
  const errorMessage = antmedicos.message;

  const [isCreatingButton, setIsCreatingButton] = useState(false);
  const [isDeletingButton, setIsDeletingButton] = useState(false);


  const [antmedResp, setAntmed] = useState(antmedicos.meta?.antmedResp);
  const [antmedFecha, setAntmedFecha] = useState(antmedicos.meta?.metaFecha);
  const [antmedTipo, setAntmedTipo] = useState(antmedicos.meta?.antmedTipo || "Ingreso");
  const [antmedFamRad, setAntmedFamRad] = useState(antmedicos.meta?.antmedFamRad);
  const [antmedFamEsp, setAntmedFamEsp] = useState(antmedicos.meta?.antmedFamEsp);
  const [antmedFumadRad, setAntmedFumadRad] = useState(antmedicos.meta?.antmedFumadRad);
  const [antmedFumadEsp, setAntmedFumadEsp] = useState(antmedicos.meta?.antmedFumadEsp);
  const antmedFumadEspKey = antmedFumadEsp?.includes("otros");
  const [antmedFumadOtr, setAntmedFumadOtr] = useState(antmedicos.meta?.antmedFumadOtr);
  const [antmedCafeRad, setAntmedCafeRad] = useState(antmedicos.meta?.antmedCafeRad);
  const [antmedCafeEsp, setAntmedCafeEsp] = useState(antmedicos.meta?.antmedCafeEsp);
  const [antmedSobredRad, setAntmedSobredRad] = useState(antmedicos.meta?.antmedSobredRad);
  const [antmedSobredEsp, setAntmedSobredEsp] = useState(antmedicos.meta?.antmedSobredEsp);
  const [antmedVihRad, setAntmedVihRad] = useState(antmedicos.meta?.antmedVihRad);
  const [antmedAccidRad, setAntmedAccidRad] = useState(antmedicos.meta?.antmedAccidRad);
  const [antmedAccidEsp, setAntmedAccidEsp] = useState(antmedicos.meta?.antmedAccidEsp);
  const [antmedIntquirRad, setAntmedIntquirRad] = useState(antmedicos.meta?.antmedIntquirRad);
  const [antmedIntquirEsp, setAntmedIntquirEsp] = useState(antmedicos.meta?.antmedIntquirEsp);
  const [antmedIntmedRad, setAntmedIntmedRad] = useState(antmedicos.meta?.antmedIntmedRad);
  const [antmedIntmedEsp, setAntmedIntmedEsp] = useState(antmedicos.meta?.antmedIntmedEsp);
  const [antmedMedicRad, setAntmedMedicRad] = useState(antmedicos.meta?.antmedMedicRad);
  const [antmedMedicEsp, setAntmedMedicEsp] = useState(antmedicos.meta?.antmedMedicEsp);
  const [antmedAprespRad, setAntmedAprespRad] = useState(antmedicos.meta?.antmedAprespRad);
  const [antmedAprespEsp, setAntmedAprespEsp] = useState(antmedicos.meta?.antmedAprespEsp);
  const antmedAprespEspKey = antmedAprespEsp?.some(item => item.label === 'Otros');
  const [antmedAprespOtr, setAntmedAprespOtr] = useState(antmedicos.meta?.antmedAprespOtr);
  const [antmedEnfcardRad, setAntmedEnfcardRad] = useState(antmedicos.meta?.antmedEnfcardRad);
  const [antmedEnfcardEsp, setAntmedEnfcardEsp] = useState(antmedicos.meta?.antmedEnfcardEsp);
  const antmedEnfcardEspKey = antmedEnfcardEsp?.some(item => item.label === 'Otros');
  const [antmedEnfcardOtr, setAntmedEnfcardOtr] = useState(antmedicos.meta?.antmedEnfcardOtr);
  const [antmedEnfvascRad, setAntmedEnfvascRad] = useState(antmedicos.meta?.antmedEnfvascRad);
  const [antmedEnfvascEsp, setAntmedEnfvascEsp] = useState(antmedicos.meta?.antmedEnfvascEsp);
  const antmedEnfvascEspKey = antmedEnfvascEsp?.some(item => item.label === 'Otros');
  const [antmedEnfvascOtr, setAntmedEnfvascOtr] = useState(antmedicos.meta?.antmedEnfvascOtr);
  const [antmedEnfdigestRad, setAntmedEnfdigestRad] = useState(antmedicos.meta?.antmedEnfdigestRad);
  const [antmedEnfdigestEsp, setAntmedEnfdigestEsp] = useState(antmedicos.meta?.antmedEnfdigestEsp);
  const antmedEnfdigestEspKey = antmedEnfdigestEsp?.some(item => item.label === 'Otros');
  const [antmedEnfdigestOtr, setAntmedEnfdigestOtr] = useState(antmedicos.meta?.antmedEnfdigestOtr);
  const [antmedEnfintestRad, setAntmedEnfintestRad] = useState(antmedicos.meta?.antmedEnfintestRad);
  const [antmedEnfintestEsp, setAntmedEnfintestEsp] = useState(antmedicos.meta?.antmedEnfintestEsp);
  const antmedEnfintestEspKey = antmedEnfintestEsp?.some(item => item.label === 'Otros');
  const [antmedEnfintestOtr, setAntmedEnfintestOtr] = useState(antmedicos.meta?.antmedEnfintestOtr);
  const [antmedEnfpancRad, setAntmedEnfpancRad] = useState(antmedicos.meta?.antmedEnfpancRad);
  const [antmedEnfpancEsp, setAntmedEnfpancEsp] = useState(antmedicos.meta?.antmedEnfpancEsp);
  const antmedEnfpancEspKey = antmedEnfpancEsp?.some(item => item.label === 'Otros');
  const [antmedEnfpancOtr, setAntmedEnfpancOtr] = useState(antmedicos.meta?.antmedEnfpancOtr);
  const [antmedEnfrenalRad, setAntmedEnfrenalRad] = useState(antmedicos.meta?.antmedEnfrenalRad);
  const [antmedEnfrenalEsp, setAntmedEnfrenalEsp] = useState(antmedicos.meta?.antmedEnfrenalEsp);
  const antmedEnfrenalEspKey = antmedEnfrenalEsp?.some(item => item.label === 'Otros');
  const [antmedEnfrenalOtr, setAntmedEnfrenalOtr] = useState(antmedicos.meta?.antmedEnfrenalOtr);
  const [antmedEnfurinRad, setAntmedEnfurinRad] = useState(antmedicos.meta?.antmedEnfurinRad);
  const [antmedEnfurinEsp, setAntmedEnfurinEsp] = useState(antmedicos.meta?.antmedEnfurinEsp);
  const antmedEnfurinEspKey = antmedEnfurinEsp?.some(item => item.label === 'Otros');
  const [antmedEnfurinOtr, setAntmedEnfurinOtr] = useState(antmedicos.meta?.antmedEnfurinOtr);
  const [antmedEnfgenitRad, setAntmedEnfgenitRad] = useState(antmedicos.meta?.antmedEnfgenitRad);
  const [antmedEnfgenitEsp, setAntmedEnfgenitEsp] = useState(antmedicos.meta?.antmedEnfgenitEsp);
  const antmedEnfgenitEspKey = antmedEnfgenitEsp?.some(item => item.label === 'Otros');
  const [antmedEnfgenitOtr, setAntmedEnfgenitOtr] = useState(antmedicos.meta?.antmedEnfgenitOtr);
  const [antmedAltmenstRad, setAntmedAltmenstRad] = useState(antmedicos.meta?.antmedAltmenstRad);
  const [antmedAltmenstEsp, setAntmedAltmenstEsp] = useState(antmedicos.meta?.antmedAltmenstEsp);
  const antmedAltmenstEspKey = antmedAltmenstEsp?.some(item => item.label === 'Otros');
  const [antmedAltmenstOtr, setAntmedAltmenstOtr] = useState(antmedicos.meta?.antmedAltmenstOtr);
  const [antmedEmbarzRad, setAntmedEmbarzRad] = useState(antmedicos.meta?.antmedEmbarzRad);
  const [antmedEmbarzEsp, setAntmedEmbarzEsp] = useState(antmedicos.meta?.antmedEmbarzEsp);
  const [antmedAbortRad, setAntmedAbortRad] = useState(antmedicos.meta?.antmedAbortRad);
  const [antmedAbortEsp, setAntmedAbortEsp] = useState(antmedicos.meta?.antmedAbortEsp);
  const [antmedEnfmetabRad, setAntmedEnfmetabRad] = useState(antmedicos.meta?.antmedEnfmetabRad);
  const [antmedEnfmetabEsp, setAntmedEnfmetabEsp] = useState(antmedicos.meta?.antmedEnfmetabEsp);
  const antmedEnfmetabEspKey = antmedEnfmetabEsp?.some(item => item.label === 'Otros');
  const [antmedEnfmetabOtr, setAntmedEnfmetabOtr] = useState(antmedicos.meta?.antmedEnfmetabOtr);
  const [antmedEnfpielRad, setAntmedEnfpielRad] = useState(antmedicos.meta?.antmedEnfpielRad);
  const [antmedEnfpielEsp, setAntmedEnfpielEsp] = useState(antmedicos.meta?.antmedEnfpielEsp);
  const antmedEnfpielEspKey = antmedEnfpielEsp?.some(item => item.label === 'Otros');
  const [antmedEnfpielOtr, setAntmedEnfpielOtr] = useState(antmedicos.meta?.antmedEnfpielOtr);
  const [antmedEnfhematRad, setAntmedEnfhematRad] = useState(antmedicos.meta?.antmedEnfhematRad);
  const [antmedEnfhematEsp, setAntmedEnfhematEsp] = useState(antmedicos.meta?.antmedEnfhematEsp);
  const antmedEnfhematEspKey = antmedEnfhematEsp?.some(item => item.label === 'Otros');
  const [antmedEnfhematOtr, setAntmedEnfhematOtr] = useState(antmedicos.meta?.antmedEnfhematOtr);
  const [antmedEnfsncsnpRad, setAntmedEnfsncsnpRad] = useState(antmedicos.meta?.antmedEnfsncsnpRad);
  const [antmedEnfsncsnpEsp, setAntmedEnfsncsnpEsp] = useState(antmedicos.meta?.antmedEnfsncsnpEsp);
  const antmedEnfsncsnpEspKey = antmedEnfsncsnpEsp?.some(item => item.label === 'Otros');
  const [antmedEnfsncsnpOtr, setAntmedEnfsncsnpOtr] = useState(antmedicos.meta?.antmedEnfsncsnpOtr);
  const [antmedAltsuenRad, setAntmedAltsuenRad] = useState(antmedicos.meta?.antmedAltsuenRad);
  const [antmedAltsuenEsp, setAntmedAltsuenEsp] = useState(antmedicos.meta?.antmedAltsuenEsp);
  const antmedAltsuenEspKey = antmedAltsuenEsp?.some(item => item.label === 'Otros');
  const [antmedAltsuenOtr, setAntmedAltsuenOtr] = useState(antmedicos.meta?.antmedAltsuenOtr);
  const [antmedAltapetRad, setAntmedAltapetRad] = useState(antmedicos.meta?.antmedAltapetRad);
  const [antmedAltapetEsp, setAntmedAltapetEsp] = useState(antmedicos.meta?.antmedAltapetEsp);
  const [antmedAltsexRad, setAntmedAltsexRad] = useState(antmedicos.meta?.antmedAltsexRad);
  const [antmedAltsexEsp, setAntmedAltsexEsp] = useState(antmedicos.meta?.antmedAltsexEsp);
  const antmedAltsexEspKey = antmedAltsexEsp?.some(item => item.label === 'Otros');
  const [antmedAltsexOtr, setAntmedAltsexOtr] = useState(antmedicos.meta?.antmedAltsexOtr);
  const [antmedPatoculRad, setAntmedPatoculRad] = useState(antmedicos.meta?.antmedPatoculRad);
  const [antmedPatoculEsp, setAntmedPatoculEsp] = useState(antmedicos.meta?.antmedPatoculEsp);
  const antmedPatoculEspKey = antmedPatoculEsp?.some(item => item.label === 'Otros');
  const [antmedPatoculOtr, setAntmedPatoculOtr] = useState(antmedicos.meta?.antmedPatoculOtr);
  const [antmedPatauditRad, setAntmedPatauditRad] = useState(antmedicos.meta?.antmedPatauditRad);
  const [antmedPatauditEsp, setAntmedPatauditEsp] = useState(antmedicos.meta?.antmedPatauditEsp);
  const antmedPatauditEspKey = antmedPatauditEsp?.some(item => item.label === 'Otros');
  const [antmedPatauditOtr, setAntmedPatauditOtr] = useState(antmedicos.meta?.antmedPatauditOtr);
  const [antmedPatolfRad, setAntmedPatolfRad] = useState(antmedicos.meta?.antmedPatolfRad);
  const [antmedPatolfEsp, setAntmedPatolfEsp] = useState(antmedicos.meta?.antmedPatolfEsp);
  const [antmedObs, setAntmedObs] = useState(antmedicos.meta?.antmedObs);
  let { tratamientoId } = useParams();
  let { pacienteId } = useParams();
  let antmedicosId = antmedicos.id;

  const antmedAprespEspOpt = [
    { value: 1, label: "Bronquitis aguda" },
    { value: 2, label: "Bronquitis crónica" },
    { value: 3, label: "Bronquitis crónica reagudizada" },
    { value: 4, label: "EPOC" },
    { value: 5, label: "Asma bronquial" },
    { value: 6, label: "Neumonía" },
    { value: 7, label: "Tbc" },
    { value: 8, label: "Otros" },
  ];
  const antmedEnfcardEspOpt = [
    { value: 1, label: "Endocarditis infecciosa" },
    { value: 2, label: "Cardiopatía insquémica" },
    { value: 3, label: "Enf. Pericardio" },
    { value: 4, label: "Insuficiencia cardiaca" },
    { value: 5, label: "Valvulopatía" },
    { value: 6, label: "Miocardiopatía" },
    { value: 7, label: "Arritmia cardíaca" },
    { value: 8, label: "Otros" },
  ];
  const antmedEnfvascEspOpt = [
    { value: 1, label: "Hipertensión arterial" },
    { value: 2, label: "Flebitis o tromboflebitis" },
    { value: 3, label: "Varices" },
    { value: 4, label: "Enf. vasos linfáticos" },
    { value: 5, label: "Otros" },
  ];
  const antmedEnfdigestEspOpt = [
    { value: 1, label: "Enf. Boca" },
    { value: 2, label: "Enf. Esófago" },
    { value: 3, label: "Gastritis crónica" },
    { value: 4, label: "Úlcera gástrica o intestinal" },
    { value: 5, label: "Gastritis hemorrágica" },
    { value: 6, label: "Intestino irritable" },
    { value: 7, label: "Hernia de hiato" },
    { value: 8, label: "RGE" },
    { value: 9, label: "Otros" },
  ];
  const antmedEnfintestEspOpt = [
    { value: 1, label: "Estreñimiento" },
    { value: 2, label: "Diarrea" },
    { value: 3, label: "Otros" },
  ];
  const antmedEnfpancEspOpt = [
    { value: 1, label: "Hepatitis A" },
    { value: 2, label: "Hepatitis B" },
    { value: 3, label: "Hepatitis C" },
    { value: 4, label: "Hepatitis D" },
    { value: 5, label: "Hepatopatía alcohólica" },
    { value: 6, label: "Pancreatitis crónica" },
    { value: 7, label: "Enfermedad biliar" },
    { value: 8, label: "Pancreatitis aguda" },
    { value: 9, label: "Otros" },
  ];
  const antmedEnfrenalEspOpt = [
    { value: 1, label: "Litiasis renal" },
    { value: 2, label: "Insuficiencia renal" },
    { value: 3, label: "Nefropatía infecciosa" },
    { value: 4, label: "Nefropatía glomerular" },
    { value: 5, label: "Nefropatía vascular" },
    { value: 6, label: "Nefropatía tóxica" },
    { value: 7, label: "Otros" },
  ];
  const antmedEnfurinEspOpt = [
    { value: 1, label: "Patología infecciosa" },
    { value: 2, label: "Enf. Prostática" },
    { value: 3, label: "Otros" },
  ];
  const antmedEnfgenitEspOpt = [
    { value: 1, label: "Enf. venérea" },
    { value: 2, label: "Fimosis" },
    { value: 3, label: "Otros" },
  ];
  const antmedAltmenstEspOpt = [
    { value: 1, label: "Amenorrea" },
    { value: 2, label: "Dismenorrea" },
    { value: 3, label: "Otros" },
  ];
  const antmedEnfmetabEspOpt = [
    { value: 1, label: "Diabetes" },
    { value: 2, label: "Obesidad" },
    { value: 3, label: "Anorexia" },
    { value: 4, label: "Enf. Tiroides o paratiroides" },
    { value: 5, label: "Enf. Glándulas suprarrenales" },
    { value: 6, label: "Dislipemia" },
    { value: 7, label: "Otros" },
  ];
  const antmedEnfpielEspOpt = [
    { value: 1, label: "Dermatis seborreica" },
    { value: 2, label: "Ptiriasis vesicolor" },
    { value: 3, label: "Eczema" },
    { value: 4, label: "Otros" },
  ];
  const antmedEnfhematEspOpt = [
    { value: 1, label: "Leucemia aguda" },
    { value: 2, label: "Leucemia crónica" },
    { value: 3, label: "Enf. Ganglionar" },
    { value: 4, label: "Enf. Hemostática" },
    { value: 5, label: "Anemia" },
    { value: 6, label: "Otros" },
  ];
  const antmedEnfsncsnpEspOpt = [
    { value: 1, label: "Epilepsia" },
    { value: 2, label: "Traumatismo cráneo-encefálico" },
    { value: 3, label: "Pérdida de conciencia" },
    { value: 4, label: "Meningitis" },
    { value: 5, label: "Encefalitis" },
    { value: 6, label: "Neuritis" },
    { value: 7, label: "Psicosis" },
    { value: 8, label: "Depresión" },
    { value: 9, label: "Enf. musculares" },
    { value: 10, label: "Neuralgias" },
    { value: 11, label: "Otros" },
  ];
  const antmedAltsuenEspOpt = [
    { value: 1, label: "Ronquidos" },
    { value: 2, label: "Apnea del sueño" },
    { value: 3, label: "Insomnio de conciliación" },
    { value: 4, label: "Insomnio de mantenimiento" },
    { value: 5, label: "Otros" },
  ];
  const antmedAltsexEspOpt = [
    { value: 1, label: "Inhibición" },
    { value: 2, label: "Exaltación" },
    { value: 3, label: "Alteración eyaculación" },
    { value: 4, label: "Otros" },
  ];
  const antmedPatoculEspOpt = [
    { value: 1, label: "Glaucoma" },
    { value: 2, label: "Aumento de tensión intraocular" },
    { value: 3, label: "Conjuntivitis" },
    { value: 4, label: "Otros" },
  ];
  const antmedPatauditEspOpt = [
    { value: 1, label: "Hipoacusia" },
    { value: 2, label: "Otros" },
  ];

  const antmedDate = new Date(antmedicos.date);
  const diffDate = (Math.abs(new Date() - antmedDate) / 36e5);

  const submitAntmedicos = async (e) => {
    e.preventDefault();
    setIsCreatingButton(true);
    try {
      await AntmedicosUpdate(
        antmedResp,
        antmedFecha,
        antmedTipo,
        antmedFamRad,
        antmedFamEsp,
        antmedFumadRad,
        antmedFumadEsp,
        antmedFumadOtr,
        antmedCafeRad,
        antmedCafeEsp,
        antmedSobredRad,
        antmedSobredEsp,
        antmedVihRad,
        antmedAccidRad,
        antmedAccidEsp,
        antmedIntquirRad,
        antmedIntquirEsp,
        antmedIntmedRad,
        antmedIntmedEsp,
        antmedMedicRad,
        antmedMedicEsp,
        antmedAprespRad,
        antmedAprespEsp,
        antmedAprespOtr,
        antmedEnfcardRad,
        antmedEnfcardEsp,
        antmedEnfcardOtr,
        antmedEnfvascRad,
        antmedEnfvascEsp,
        antmedEnfvascOtr,
        antmedEnfdigestRad,
        antmedEnfdigestEsp,
        antmedEnfdigestOtr,
        antmedEnfintestRad,
        antmedEnfintestEsp,
        antmedEnfintestOtr,
        antmedEnfpancRad,
        antmedEnfpancEsp,
        antmedEnfpancOtr,
        antmedEnfrenalRad,
        antmedEnfrenalEsp,
        antmedEnfrenalOtr,
        antmedEnfurinRad,
        antmedEnfurinEsp,
        antmedEnfurinOtr,
        antmedEnfgenitRad,
        antmedEnfgenitEsp,
        antmedEnfgenitOtr,
        antmedAltmenstRad,
        antmedAltmenstEsp,
        antmedAltmenstOtr,
        antmedEmbarzRad,
        antmedEmbarzEsp,
        antmedAbortRad,
        antmedAbortEsp,
        antmedEnfmetabRad,
        antmedEnfmetabEsp,
        antmedEnfmetabOtr,
        antmedEnfpielRad,
        antmedEnfpielEsp,
        antmedEnfpielOtr,
        antmedEnfhematRad,
        antmedEnfhematEsp,
        antmedEnfhematOtr,
        antmedEnfsncsnpRad,
        antmedEnfsncsnpEsp,
        antmedEnfsncsnpOtr,
        antmedAltsuenRad,
        antmedAltsuenEsp,
        antmedAltsuenOtr,
        antmedAltapetRad,
        antmedAltapetEsp,
        antmedAltsexRad,
        antmedAltsexEsp,
        antmedAltsexOtr,
        antmedPatoculRad,
        antmedPatoculEsp,
        antmedPatoculOtr,
        antmedPatauditRad,
        antmedPatauditEsp,
        antmedPatauditOtr,
        antmedPatolfRad,
        antmedPatolfEsp,
        antmedObs,
        tratamientoId,
        pacienteId,
        antmedicosId
      ).then(
        (val) => {
          navigate(`../${tratamientoId}/antecedentes/medicos/${antmedicosId}`);
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  const deleteItem = async (e) => {
    e.preventDefault();
    setIsDeletingButton(true);
    try {
      await AntmedicosDelete(
        antmedicosId
      ).then(
        (val) => {
          window.location.replace("../");
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div id='content'>
        {antmedicos.length === 0 ? (
          <div>Cargando...</div>
        ) : (
        errorMessage? (
          <p>{errorMessage}</p>
        ) : (
          <form id='formUpdatelement' onSubmit={submitAntmedicos}>
            <fieldset id='disabledContainer'>
              <div className='grid--2col'>
                <div className='field'>
                  <label htmlFor='antmedResp'>Responsable</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedResp'
                      required
                      type='text'
                      value={antmedResp}
                      onChange={(e) => setAntmed(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='antmedFecha'>Fecha visita</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedFecha'
                      required
                      type='date'
                      value={antmedFecha}
                      onChange={(e) => setAntmedFecha(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='antmedTipo'>Tipo</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='antmedTipo'
                        required
                        name='antmedTipo'
                        value={antmedTipo}
                        onChange={(e) => setAntmedTipo(e.target.value)}
                      >
                        <option disabled value=''> -- Selecciona una opción --</option>
                        <option value='Valoración'>Valoración</option>
                        <option value='Ingreso'>Ingreso</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <h3>Antecedentes familiares</h3>
              <div className='grid--2col'>
                <div className='field key' data-key={antmedFamRad?.toString()}>
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Alguno de sus familiares ha tenido o tiene problemas médicos?
                    </label>
                    <label className='radio' htmlFor='antmedFamRadSi'>
                      <input
                        id='antmedFamRadSi'
                        name='antmedFamRad'
                        type='radio'
                        value='Si'
                        checked={antmedFamRad === "Si"}
                        onChange={(e) => setAntmedFamRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedFamRadNo'>
                      <input
                        id='antmedFamRadNo'
                        name='antmedFamRad'
                        type='radio'
                        value='No'
                        checked={antmedFamRad === "No"}
                        onChange={(e) => setAntmedFamRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antmedFamEsp'>
                    Especificar problemas médicos de sus familiares
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedFamEsp'
                      type='text'
                      value={antmedFamEsp}
                      onChange={(e) => setAntmedFamEsp(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <h3>Antecedentes personales</h3>
              <div className='grid--2col'>
                <div className='field key' data-key={antmedFumadRad?.toString()}>
                  <div className='control'>
                    <label className='radio-title'>
                      ¿El paciente es fumador habitual?
                    </label>
                    <label className='radio' htmlFor='antmedFumadRadSi'>
                      <input
                        id='antmedFumadRadSi'
                        name='antmedFumadRad'
                        type='radio'
                        value='Si'
                        checked={antmedFumadRad === "Si"}
                        onChange={(e) => setAntmedFumadRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedFumadRadNo'>
                      <input
                        id='antmedFumadRadNo'
                        name='antmedFumadRad'
                        type='radio'
                        value='No'
                        checked={antmedFumadRad === "No"}
                        onChange={(e) => setAntmedFumadRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock' data-key={antmedFumadEspKey}>
                  <label htmlFor='antmedFumadEsp'>
                    Especificar
                  </label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='antmedFumadEsp'
                        name='antmedFumadEsp'
                        value={antmedFumadEsp}
                        onChange={(e) => setAntmedFumadEsp(e.target.value)}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='menos-10-cigar'>
                          Menos de 10 cigarrillos
                        </option>
                        <option value='10-20-cigar'>
                          Entre 10-20 cigarrillos
                        </option>
                        <option value='mas-20-cigar'>
                          Más de 20 cigarrillos
                        </option>
                        <option value='otros-cigar'>
                          Otros
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className='field sublock'>
                  <label htmlFor='antmedFumadOtr'>
                    Especificar otros
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedFumadOtr'
                      type='text'
                      value={antmedFumadOtr}
                      onChange={(e) => setAntmedFumadOtr(e.target.value)}
                    />
                  </div>
                </div>

                <div className='field key' data-key={antmedCafeRad?.toString()}>
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Consume café habitualmente?
                    </label>
                    <label className='radio' htmlFor='antmedCafeRadSi'>
                      <input
                        id='antmedCafeRadSi'
                        name='antmedCafeRad'
                        type='radio'
                        value='Si'
                        checked={antmedCafeRad === "Si"}
                        onChange={(e) => setAntmedCafeRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedCafeRadNo'>
                      <input
                        id='antmedCafeRadNo'
                        name='antmedCafeRad'
                        type='radio'
                        value='No'
                        checked={antmedCafeRad === "No"}
                        onChange={(e) => setAntmedCafeRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antmedCafeEsp'>
                    ¿Cuántos cafés toma por día?
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedCafeEsp'
                      type='text'
                      value={antmedCafeEsp}
                      onChange={(e) => setAntmedCafeEsp(e.target.value)}
                    />
                  </div>
                </div>
                <div
                  className='field key'
                  data-key={antmedSobredRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sufrido algún episodio de sobredosis?
                    </label>
                    <label className='radio' htmlFor='antmedSobredRadSi'>
                      <input
                        id='antmedSobredRadSi'
                        name='antmedSobredRad'
                        type='radio'
                        value='Si'
                        checked={antmedSobredRad === "Si"}
                        onChange={(e) => setAntmedSobredRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedSobredRadNo'>
                      <input
                        id='antmedSobredRadNo'
                        name='antmedSobredRad'
                        type='radio'
                        value='No'
                        checked={antmedSobredRad === "No"}
                        onChange={(e) => setAntmedSobredRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antmedSobredEsp'>
                    Especificar detalles de sobredosis
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedSobredEsp'
                      type='text'
                      value={antmedSobredEsp}
                      onChange={(e) => setAntmedSobredEsp(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field key' data-key={antmedVihRad?.toString()}>
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Tiene anticuerpos contra el VIH?
                    </label>
                    <label className='radio' htmlFor='antmedVihRadSi'>
                      <input
                        id='antmedVihRadSi'
                        name='antmedVihRad'
                        type='radio'
                        value='Si'
                        checked={antmedVihRad === "Si"}
                        onChange={(e) => setAntmedVihRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedVihRadNo'>
                      <input
                        id='antmedVihRadNo'
                        name='antmedVihRad'
                        type='radio'
                        value='No'
                        checked={antmedVihRad === "No"}
                        onChange={(e) => setAntmedVihRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>
                <div className='field key' data-key={antmedAccidRad?.toString()}>
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sufrido algún accidente que le haya dejado secuela?
                    </label>
                    <label className='radio' htmlFor='antmedAccidRadSi'>
                      <input
                        id='antmedAccidRadSi'
                        name='antmedAccidRad'
                        type='radio'
                        value='Si'
                        checked={antmedAccidRad === "Si"}
                        onChange={(e) => setAntmedAccidRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedAccidRadNo'>
                      <input
                        id='antmedAccidRadNo'
                        name='antmedAccidRad'
                        type='radio'
                        value='No'
                        checked={antmedAccidRad === "No"}
                        onChange={(e) => setAntmedAccidRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antmedAccidEsp'>Especificar accidente</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedAccidEsp'
                      type='text'
                      value={antmedAccidEsp}
                      onChange={(e) => setAntmedAccidEsp(e.target.value)}
                    />
                  </div>
                </div>
                <div
                  className='field key'
                  data-key={antmedIntquirRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sido sometido a alguna intervención quirúrgica?
                    </label>
                    <label className='radio' htmlFor='antmedIntquirRadSi'>
                      <input
                        id='antmedIntquirRadSi'
                        name='antmedIntquirRad'
                        type='radio'
                        value='Si'
                        checked={antmedIntquirRad === "Si"}
                        onChange={(e) => setAntmedIntquirRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedIntquirRadNo'>
                      <input
                        id='antmedIntquirRadNo'
                        name='antmedIntquirRad'
                        type='radio'
                        value='No'
                        checked={antmedIntquirRad === "No"}
                        onChange={(e) => setAntmedIntquirRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antmedIntquirEsp'>
                    Especificar intervención quirúrgica
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedIntquirEsp'
                      type='text'
                      value={antmedIntquirEsp}
                      onChange={(e) => setAntmedIntquirEsp(e.target.value)}
                    />
                  </div>
                </div>
                <div
                  className='field key'
                  data-key={antmedIntmedRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha padecido o padece alergia o intolerancia a algún
                      medicamento?
                    </label>
                    <label className='radio' htmlFor='antmedIntmedRadSi'>
                      <input
                        id='antmedIntmedRadSi'
                        name='antmedIntmedRad'
                        type='radio'
                        value='Si'
                        checked={antmedIntmedRad === "Si"}
                        onChange={(e) => setAntmedIntmedRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedIntmedRadNo'>
                      <input
                        id='antmedIntmedRadNo'
                        name='antmedIntmedRad'
                        type='radio'
                        value='No'
                        checked={antmedIntmedRad === "No"}
                        onChange={(e) => setAntmedIntmedRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antmedIntmedEsp'>
                    Especificar intolerancia a medicamento
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedIntmedEsp'
                      type='text'
                      value={antmedIntmedEsp}
                      onChange={(e) => setAntmedIntmedEsp(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field key' data-key={antmedMedicRad?.toString()}>
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Está actualmente tomando alguna medicación (no
                      psicofármacos)?
                    </label>
                    <label className='radio' htmlFor='antmedMedicRadSi'>
                      <input
                        id='antmedMedicRadSi'
                        name='antmedMedicRad'
                        type='radio'
                        value='Si'
                        checked={antmedMedicRad === "Si"}
                        onChange={(e) => setAntmedMedicRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedMedicRadNo'>
                      <input
                        id='antmedMedicRadNo'
                        name='antmedMedicRad'
                        type='radio'
                        value='No'
                        checked={antmedMedicRad === "No"}
                        onChange={(e) => setAntmedMedicRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antmedMedicEsp'>Especificar medicación</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedMedicEsp'
                      type='text'
                      value={antmedMedicEsp}
                      onChange={(e) => setAntmedMedicEsp(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <h3>Exploración por aparatos</h3>
              <div className='grid--2col'>
                <div
                  className='field key'
                  data-key={antmedAprespRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sufrido o sufre alguna enfermedad del aparato
                      respiratorio?
                    </label>
                    <label className='radio' htmlFor='antmedAprespRadSi'>
                      <input
                        id='antmedAprespRadSi'
                        name='antmedAprespRad'
                        type='radio'
                        value='Si'
                        checked={antmedAprespRad === "Si"}
                        onChange={(e) => setAntmedAprespRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedAprespRadNo'>
                      <input
                        id='antmedAprespRadNo'
                        name='antmedAprespRad'
                        type='radio'
                        value='No'
                        checked={antmedAprespRad === "No"}
                        onChange={(e) => setAntmedAprespRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock' data-key={antmedAprespEspKey}>
                  <label htmlFor='antmedAprespEsp'>
                    Especificar enfermedad del aparato respiratorio
                  </label>
                  <div className='control'>
                    <Select
                      isMulti
                      value={antmedAprespEsp}
                      name='antmedAprespEsp'
                      options={antmedAprespEspOpt}
                      className='basic-multi-select'
                      classNamePrefix='select'
                      placeholder='Seleccionar enfermedad'
                      onChange={setAntmedAprespEsp}
                    />
                  </div>
                </div>
                <div className='field sublock'>
                  <label htmlFor='antmedAprespOtr'>
                    Especificar otros
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedAprespOtr'
                      type='text'
                      value={antmedAprespOtr}
                      onChange={(e) => setAntmedAprespOtr(e.target.value)}
                    />
                  </div>
                </div>

                <div
                  className='field key'
                  data-key={antmedEnfcardRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sufrido o sufre alguna enfermedad cardiaca?
                    </label>
                    <label className='radio' htmlFor='antmedEnfcardRadSi'>
                      <input
                        id='antmedEnfcardRadSi'
                        name='antmedEnfcardRad'
                        type='radio'
                        value='Si'
                        checked={antmedEnfcardRad === "Si"}
                        onChange={(e) => setAntmedEnfcardRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedEnfcardRadNo'>
                      <input
                        id='antmedEnfcardRadNo'
                        name='antmedEnfcardRad'
                        type='radio'
                        value='No'
                        checked={antmedEnfcardRad === "No"}
                        onChange={(e) => setAntmedEnfcardRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock' data-key={antmedEnfcardEspKey}>
                  <label htmlFor='antmedEnfcardEsp'>
                    Especificar enfermedad cardiaca
                  </label>
                  <div className='control'>
                    <Select
                      isMulti
                      name='antmedEnfcardEsp'
                      value={antmedEnfcardEsp}
                      options={antmedEnfcardEspOpt}
                      className='basic-multi-select'
                      classNamePrefix='select'
                      placeholder='Seleccionar enfermedad'
                      onChange={setAntmedEnfcardEsp}
                    />
                  </div>
                </div>
                <div className='field sublock'>
                  <label htmlFor='antmedEnfcardOtr'>
                    Especificar otros
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedEnfcardOtr'
                      type='text'
                      value={antmedEnfcardOtr}
                      onChange={(e) => setAntmedEnfcardOtr(e.target.value)}
                    />
                  </div>
                </div>

                <div
                  className='field key'
                  data-key={antmedEnfvascRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sufrido o sufre alguna enfermedad vascular?
                    </label>
                    <label className='radio' htmlFor='antmedEnfvascRadSi'>
                      <input
                        id='antmedEnfvascRadSi'
                        name='antmedEnfvascRad'
                        type='radio'
                        value='Si'
                        checked={antmedEnfvascRad === "Si"}
                        onChange={(e) => setAntmedEnfvascRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedEnfvascRadNo'>
                      <input
                        id='antmedEnfvascRadNo'
                        name='antmedEnfvascRad'
                        type='radio'
                        value='No'
                        checked={antmedEnfvascRad === "No"}
                        onChange={(e) => setAntmedEnfvascRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock' data-key={antmedEnfvascEspKey}>
                  <label htmlFor='antmedEnfvascEsp'>
                    Especificar enfermedad vascular
                  </label>
                  <div className='control'>
                    <Select
                      isMulti
                      name='antmedEnfvascEsp'
                      value={antmedEnfvascEsp}
                      options={antmedEnfvascEspOpt}
                      className='basic-multi-select'
                      classNamePrefix='select'
                      placeholder='Seleccionar enfermedad'
                      onChange={setAntmedEnfvascEsp}
                    />
                  </div>
                </div>
                <div className='field sublock'>
                  <label htmlFor='antmedEnfvascOtr'>
                    Especificar otros
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedEnfvascOtr'
                      type='text'
                      value={antmedEnfvascOtr}
                      onChange={(e) => setAntmedEnfvascOtr(e.target.value)}
                    />
                  </div>
                </div>

                <div
                  className='field key'
                  data-key={antmedEnfdigestRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sufrido o sufre alguna enfermedad digestiva?
                    </label>
                    <label className='radio' htmlFor='antmedEnfdigestRadSi'>
                      <input
                        id='antmedEnfdigestRadSi'
                        name='antmedEnfdigestRad'
                        type='radio'
                        value='Si'
                        checked={antmedEnfdigestRad === "Si"}
                        onChange={(e) => setAntmedEnfdigestRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedEnfdigestRadNo'>
                      <input
                        id='antmedEnfdigestRadNo'
                        name='antmedEnfdigestRad'
                        type='radio'
                        value='No'
                        checked={antmedEnfdigestRad === "No"}
                        onChange={(e) => setAntmedEnfdigestRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock' data-key={antmedEnfdigestEspKey}>
                  <label htmlFor='antmedEnfdigestEsp'>
                    Especificar enfermedad digestiva
                  </label>
                  <div className='control'>
                    <Select
                      isMulti
                      name='antmedEnfdigestEsp'
                      value={antmedEnfdigestEsp}
                      options={antmedEnfdigestEspOpt}
                      className='basic-multi-select'
                      classNamePrefix='select'
                      placeholder='Seleccionar enfermedad'
                      onChange={setAntmedEnfdigestEsp}
                    />
                  </div>
                </div>
                <div className='field sublock'>
                  <label htmlFor='antmedEnfdigestOtr'>
                    Especificar otros
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedEnfdigestOtr'
                      type='text'
                      value={antmedEnfdigestOtr}
                      onChange={(e) => setAntmedEnfdigestOtr(e.target.value)}
                    />
                  </div>
                </div>

                <div
                  className='field key'
                  data-key={antmedEnfintestRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sufrido o sufre alteración del tracto intestinal?
                    </label>
                    <label className='radio' htmlFor='antmedEnfintestRadSi'>
                      <input
                        id='antmedEnfintestRadSi'
                        name='antmedEnfintestRad'
                        type='radio'
                        value='Si'
                        checked={antmedEnfintestRad === "Si"}
                        onChange={(e) => setAntmedEnfintestRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedEnfintestRadNo'>
                      <input
                        id='antmedEnfintestRadNo'
                        name='antmedEnfintestRad'
                        type='radio'
                        value='No'
                        checked={antmedEnfintestRad === "No"}
                        onChange={(e) => setAntmedEnfintestRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock' data-key={antmedEnfintestEspKey}>
                  <label htmlFor='antmedEnfintestEsp'>
                    Especificar alteración del tracto intestinal
                  </label>
                  <div className='control'>
                    <Select
                      isMulti
                      name='antmedEnfintestEsp'
                      value={antmedEnfintestEsp}
                      options={antmedEnfintestEspOpt}
                      className='basic-multi-select'
                      classNamePrefix='select'
                      placeholder='Seleccionar enfermedad'
                      onChange={setAntmedEnfintestEsp}
                    />
                  </div>
                </div>
                <div className='field sublock'>
                  <label htmlFor='antmedEnfintestOtr'>
                    Especificar otros
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedEnfintestOtr'
                      type='text'
                      value={antmedEnfintestOtr}
                      onChange={(e) => setAntmedEnfintestOtr(e.target.value)}
                    />
                  </div>
                </div>

                <div
                  className='field key'
                  data-key={antmedEnfpancRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sufrido o sufre alguna enfermedad del páncreas o del
                      hígado?
                    </label>
                    <label className='radio' htmlFor='antmedEnfpancRadSi'>
                      <input
                        id='antmedEnfpancRadSi'
                        name='antmedEnfpancRad'
                        type='radio'
                        value='Si'
                        checked={antmedEnfpancRad === "Si"}
                        onChange={(e) => setAntmedEnfpancRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedEnfpancRadNo'>
                      <input
                        id='antmedEnfpancRadNo'
                        name='antmedEnfpancRad'
                        type='radio'
                        value='No'
                        checked={antmedEnfpancRad === "No"}
                        onChange={(e) => setAntmedEnfpancRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock' data-key={antmedEnfpancEspKey}>
                  <label htmlFor='antmedEnfpancEsp'>
                    Especificar enfermedad del páncreas o del hígado
                  </label>
                  <div className='control'>
                    <Select
                      isMulti
                      name='antmedEnfpancEsp'
                      value={antmedEnfpancEsp}
                      options={antmedEnfpancEspOpt}
                      className='basic-multi-select'
                      classNamePrefix='select'
                      placeholder='Seleccionar enfermedad'
                      onChange={setAntmedEnfpancEsp}
                    />
                  </div>
                </div>
                <div className='field sublock'>
                  <label htmlFor='antmedEnfpancOtr'>
                    Especificar otros
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedEnfpancOtr'
                      type='text'
                      value={antmedEnfpancOtr}
                      onChange={(e) => setAntmedEnfpancOtr(e.target.value)}
                    />
                  </div>
                </div>

                <div
                  className='field key'
                  data-key={antmedEnfrenalRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sufrido o sufre alguna enfermedad renal?
                    </label>
                    <label className='radio' htmlFor='antmedEnfrenalRadSi'>
                      <input
                        id='antmedEnfrenalRadSi'
                        name='antmedEnfrenalRad'
                        type='radio'
                        value='Si'
                        checked={antmedEnfrenalRad === "Si"}
                        onChange={(e) => setAntmedEnfrenalRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedEnfrenalRadNo'>
                      <input
                        id='antmedEnfrenalRadNo'
                        name='antmedEnfrenalRad'
                        type='radio'
                        value='No'
                        checked={antmedEnfrenalRad === "No"}
                        onChange={(e) => setAntmedEnfrenalRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock' data-key={antmedEnfrenalEspKey}>
                  <label htmlFor='antmedEnfrenalEsp'>
                    Especificar enfermedad renal
                  </label>
                  <div className='control'>
                    <Select
                      isMulti
                      name='antmedEnfrenalEsp'
                      value={antmedEnfrenalEsp}
                      options={antmedEnfrenalEspOpt}
                      className='basic-multi-select'
                      classNamePrefix='select'
                      placeholder='Seleccionar enfermedad'
                      onChange={setAntmedEnfrenalEsp}
                    />
                  </div>
                </div>
                <div className='field sublock'>
                  <label htmlFor='antmedEnfrenalOtr'>
                    Especificar otros
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedEnfrenalOtr'
                      type='text'
                      value={antmedEnfrenalOtr}
                      onChange={(e) => setAntmedEnfrenalOtr(e.target.value)}
                    />
                  </div>
                </div>

                <div
                  className='field key'
                  data-key={antmedEnfurinRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sufrido o sufre enfermedad en las vías urinarias?
                    </label>
                    <label className='radio' htmlFor='antmedEnfurinRadSi'>
                      <input
                        id='antmedEnfurinRadSi'
                        name='antmedEnfurinRad'
                        type='radio'
                        value='Si'
                        checked={antmedEnfurinRad === "Si"}
                        onChange={(e) => setAntmedEnfurinRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedEnfurinRadNo'>
                      <input
                        id='antmedEnfurinRadNo'
                        name='antmedEnfurinRad'
                        type='radio'
                        value='No'
                        checked={antmedEnfurinRad === "No"}
                        onChange={(e) => setAntmedEnfurinRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock' data-key={antmedEnfurinEspKey}>
                  <label htmlFor='antmedEnfurinEsp'>
                    Especificar enfermedad en las vías urinarias
                  </label>
                  <div className='control'>
                    <Select
                      isMulti
                      name='antmedEnfurinEsp'
                      value={antmedEnfurinEsp}
                      options={antmedEnfurinEspOpt}
                      className='basic-multi-select'
                      classNamePrefix='select'
                      placeholder='Seleccionar enfermedad'
                      onChange={setAntmedEnfurinEsp}
                    />
                  </div>
                </div>
                <div className='field sublock'>
                  <label htmlFor='antmedEnfurinOtr'>
                    Especificar otros
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedEnfurinOtr'
                      type='text'
                      value={antmedEnfurinOtr}
                      onChange={(e) => setAntmedEnfurinOtr(e.target.value)}
                    />
                  </div>
                </div>

                <div
                  className='field key'
                  data-key={antmedEnfgenitRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sufrido o sufre enfermedad del aparato genital?
                    </label>
                    <label className='radio' htmlFor='antmedEnfgenitRadSi'>
                      <input
                        id='antmedEnfgenitRadSi'
                        name='antmedEnfgenitRad'
                        type='radio'
                        value='Si'
                        checked={antmedEnfgenitRad === "Si"}
                        onChange={(e) => setAntmedEnfgenitRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedEnfgenitRadNo'>
                      <input
                        id='antmedEnfgenitRadNo'
                        name='antmedEnfgenitRad'
                        type='radio'
                        value='No'
                        checked={antmedEnfgenitRad === "No"}
                        onChange={(e) => setAntmedEnfgenitRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock' data-key={antmedEnfgenitEspKey}>
                  <label htmlFor='antmedEnfgenitEsp'>
                    Especificar enfermedad del aparato genital
                  </label>
                  <div className='control'>
                    <Select
                      isMulti
                      name='antmedEnfgenitEsp'
                      value={antmedEnfgenitEsp}
                      options={antmedEnfgenitEspOpt}
                      className='basic-multi-select'
                      classNamePrefix='select'
                      placeholder='Seleccionar enfermedad'
                      onChange={setAntmedEnfgenitEsp}
                    />
                  </div>
                </div>
                <div className='field sublock'>
                  <label htmlFor='antmedEnfgenitOtr'>
                    Especificar otros
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedEnfgenitOtr'
                      type='text'
                      value={antmedEnfgenitOtr}
                      onChange={(e) => setAntmedEnfgenitOtr(e.target.value)}
                    />
                  </div>
                </div>

                <div
                  className='field key'
                  data-key={antmedAltmenstRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sufrido o sufre alteraciones en la menstruación?
                    </label>
                    <label className='radio' htmlFor='antmedAltmenstRadSi'>
                      <input
                        id='antmedAltmenstRadSi'
                        name='antmedAltmenstRad'
                        type='radio'
                        value='Si'
                        checked={antmedAltmenstRad === "Si"}
                        onChange={(e) => setAntmedAltmenstRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedAltmenstRadNo'>
                      <input
                        id='antmedAltmenstRadNo'
                        name='antmedAltmenstRad'
                        type='radio'
                        value='No'
                        checked={antmedAltmenstRad === "No"}
                        onChange={(e) => setAntmedAltmenstRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock' data-key={antmedAltmenstEspKey}>
                  <label htmlFor='antmedAltmenstEsp'>
                    Especificar alteraciones en la menstruación
                  </label>
                  <div className='control'>
                    <Select
                      isMulti
                      name='antmedAltmenstEsp'
                      value={antmedAltmenstEsp}
                      options={antmedAltmenstEspOpt}
                      className='basic-multi-select'
                      classNamePrefix='select'
                      placeholder='Seleccionar alteración'
                      onChange={setAntmedAltmenstEsp}
                    />
                  </div>
                </div>
                <div className='field sublock'>
                  <label htmlFor='antmedAltmenstOtr'>
                    Especificar otros
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedAltmenstOtr'
                      type='text'
                      value={antmedAltmenstOtr}
                      onChange={(e) => setAntmedAltmenstOtr(e.target.value)}
                    />
                  </div>
                </div>

                <div
                  className='field key'
                  data-key={antmedEmbarzRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha tenido algún embarazo?
                    </label>
                    <label className='radio' htmlFor='antmedEmbarzRadSi'>
                      <input
                        id='antmedEmbarzRadSi'
                        name='antmedEmbarzRad'
                        type='radio'
                        value='Si'
                        checked={antmedEmbarzRad === "Si"}
                        onChange={(e) => setAntmedEmbarzRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedEmbarzRadNo'>
                      <input
                        id='antmedEmbarzRadNo'
                        name='antmedEmbarzRad'
                        type='radio'
                        value='No'
                        checked={antmedEmbarzRad === "No"}
                        onChange={(e) => setAntmedEmbarzRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antmedEmbarzEsp'>Especificar embarazo</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedEmbarzEsp'
                      type='text'
                      value={antmedEmbarzEsp}
                      onChange={(e) => setAntmedEmbarzEsp(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field key' data-key={antmedAbortRad?.toString()}>
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha tenido algún aborto?
                    </label>
                    <label className='radio' htmlFor='antmedAbortRadSi'>
                      <input
                        id='antmedAbortRadSi'
                        name='antmedAbortRad'
                        type='radio'
                        value='Si'
                        checked={antmedAbortRad === "Si"}
                        onChange={(e) => setAntmedAbortRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedAbortRadNo'>
                      <input
                        id='antmedAbortRadNo'
                        name='antmedAbortRad'
                        type='radio'
                        value='No'
                        checked={antmedAbortRad === "No"}
                        onChange={(e) => setAntmedAbortRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antmedAbortEsp'>Especificar aborto</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedAbortEsp'
                      type='text'
                      value={antmedAbortEsp}
                      onChange={(e) => setAntmedAbortEsp(e.target.value)}
                    />
                  </div>
                </div>
                <div
                  className='field key'
                  data-key={antmedEnfmetabRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sufrido o sufre alguna enfermedad metabólica?
                    </label>
                    <label className='radio' htmlFor='antmedEnfmetabRadSi'>
                      <input
                        id='antmedEnfmetabRadSi'
                        name='antmedEnfmetabRad'
                        type='radio'
                        value='Si'
                        checked={antmedEnfmetabRad === "Si"}
                        onChange={(e) => setAntmedEnfmetabRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedEnfmetabRadNo'>
                      <input
                        id='antmedEnfmetabRadNo'
                        name='antmedEnfmetabRad'
                        type='radio'
                        value='No'
                        checked={antmedEnfmetabRad === "No"}
                        onChange={(e) => setAntmedEnfmetabRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock' data-key={antmedEnfmetabEspKey}>
                  <label htmlFor='antmedEnfmetabEsp'>
                    Especificar enfermedad metabólica
                  </label>
                  <div className='control'>
                    <Select
                      isMulti
                      name='antmedEnfmetabEsp'
                      value={antmedEnfmetabEsp}
                      options={antmedEnfmetabEspOpt}
                      className='basic-multi-select'
                      classNamePrefix='select'
                      placeholder='Seleccionar enfermedad'
                      onChange={setAntmedEnfmetabEsp}
                    />
                  </div>
                </div>
                <div className='field sublock'>
                  <label htmlFor='antmedEnfmetabOtr'>
                    Especificar otros
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedEnfmetabOtr'
                      type='text'
                      value={antmedEnfmetabOtr}
                      onChange={(e) => setAntmedEnfmetabOtr(e.target.value)}
                    />
                  </div>
                </div>

                <div
                  className='field key'
                  data-key={antmedEnfpielRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sufrido o sufre alguna enfermedad de piel o faneras?
                    </label>
                    <label className='radio' htmlFor='antmedEnfpielRadSi'>
                      <input
                        id='antmedEnfpielRadSi'
                        name='antmedEnfpielRad'
                        type='radio'
                        value='Si'
                        checked={antmedEnfpielRad === "Si"}
                        onChange={(e) => setAntmedEnfpielRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedEnfpielRadNo'>
                      <input
                        id='antmedEnfpielRadNo'
                        name='antmedEnfpielRad'
                        type='radio'
                        value='No'
                        checked={antmedEnfpielRad === "No"}
                        onChange={(e) => setAntmedEnfpielRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock' data-key={antmedEnfpielEspKey}>
                  <label htmlFor='antmedEnfpielEsp'>
                    Especificar enfermedad de piel o faneras
                  </label>
                  <Select
                      isMulti
                      name='antmedEnfpielEsp'
                      value={antmedEnfpielEsp}
                      options={antmedEnfpielEspOpt}
                      className='basic-multi-select'
                      classNamePrefix='select'
                      placeholder='Seleccionar enfermedad'
                      onChange={setAntmedEnfpielEsp}
                    />
                </div>
                <div className='field sublock'>
                  <label htmlFor='antmedEnfpielOtr'>
                    Especificar otros
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedEnfpielOtr'
                      type='text'
                      value={antmedEnfpielOtr}
                      onChange={(e) => setAntmedEnfpielOtr(e.target.value)}
                    />
                  </div>
                </div>

                <div
                  className='field key'
                  data-key={antmedEnfhematRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sufrido o sufre alguna enfermedad hematológica?
                    </label>
                    <label className='radio' htmlFor='antmedEnfhematRadSi'>
                      <input
                        id='antmedEnfhematRadSi'
                        name='antmedEnfhematRad'
                        type='radio'
                        value='Si'
                        checked={antmedEnfhematRad === "Si"}
                        onChange={(e) => setAntmedEnfhematRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedEnfhematRadNo'>
                      <input
                        id='antmedEnfhematRadNo'
                        name='antmedEnfhematRad'
                        type='radio'
                        value='No'
                        checked={antmedEnfhematRad === "No"}
                        onChange={(e) => setAntmedEnfhematRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock' data-key={antmedEnfhematEspKey}>
                  <label htmlFor='antmedEnfhematEsp'>
                    Especificar enfermedad hematológica
                  </label>
                  <div className='control'>
                    <Select
                      isMulti
                      name='antmedEnfhematEsp'
                      value={antmedEnfhematEsp}
                      options={antmedEnfhematEspOpt}
                      className='basic-multi-select'
                      classNamePrefix='select'
                      placeholder='Seleccionar enfermedad'
                      onChange={setAntmedEnfhematEsp}
                    />
                  </div>
                </div>
                <div className='field sublock'>
                  <label htmlFor='antmedEnfhematOtr'>
                    Especificar otros
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedEnfhematOtr'
                      type='text'
                      value={antmedEnfhematOtr}
                      onChange={(e) => setAntmedEnfhematOtr(e.target.value)}
                    />
                  </div>
                </div>

                <div
                  className='field key'
                  data-key={antmedEnfsncsnpRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sufrido o sufre alguna enfermedad SNC o SNP?
                    </label>
                    <label className='radio' htmlFor='antmedEnfsncsnpRadSi'>
                      <input
                        id='antmedEnfsncsnpRadSi'
                        name='antmedEnfsncsnpRad'
                        type='radio'
                        value='Si'
                        checked={antmedEnfsncsnpRad === "Si"}
                        onChange={(e) => setAntmedEnfsncsnpRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedEnfsncsnpRadNo'>
                      <input
                        id='antmedEnfsncsnpRadNo'
                        name='antmedEnfsncsnpRad'
                        type='radio'
                        value='No'
                        checked={antmedEnfsncsnpRad === "No"}
                        onChange={(e) => setAntmedEnfsncsnpRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock' data-key={antmedEnfsncsnpEspKey}>
                  <label htmlFor='antmedEnfsncsnpEsp'>
                    Especificar enfermedad SNC o SNP
                  </label>
                  <div className='control'>
                    <Select
                      isMulti
                      name='antmedEnfsncsnpEsp'
                      value={antmedEnfsncsnpEsp}
                      options={antmedEnfsncsnpEspOpt}
                      className='basic-multi-select'
                      classNamePrefix='select'
                      placeholder='Seleccionar enfermedad'
                      onChange={setAntmedEnfsncsnpEsp}
                    />
                  </div>
                </div>
                <div className='field sublock'>
                  <label htmlFor='antmedEnfsncsnpOtr'>
                    Especificar otros
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedEnfsncsnpOtr'
                      type='text'
                      value={antmedEnfsncsnpOtr}
                      onChange={(e) => setAntmedEnfsncsnpOtr(e.target.value)}
                    />
                  </div>
                </div>

                <div
                  className='field key'
                  data-key={antmedAltsuenRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha presentado o presenta alteraciones del sueño?
                    </label>
                    <label className='radio' htmlFor='antmedAltsuenRadSi'>
                      <input
                        id='antmedAltsuenRadSi'
                        name='antmedAltsuenRad'
                        type='radio'
                        value='Si'
                        checked={antmedAltsuenRad === "Si"}
                        onChange={(e) => setAntmedAltsuenRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedAltsuenRadNo'>
                      <input
                        id='antmedAltsuenRadNo'
                        name='antmedAltsuenRad'
                        type='radio'
                        value='No'
                        checked={antmedAltsuenRad === "No"}
                        onChange={(e) => setAntmedAltsuenRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock' data-key={antmedAltsuenEspKey}>
                  <label htmlFor='antmedAltsuenEsp'>
                    Especificar alteraciones del sueño
                  </label>
                  <div className='control'>
                    <Select
                      isMulti
                      name='antmedAltsuenEsp'
                      value={antmedAltsuenEsp}
                      options={antmedAltsuenEspOpt}
                      className='basic-multi-select'
                      classNamePrefix='select'
                      placeholder='Seleccionar alteración'
                      onChange={setAntmedAltsuenEsp}
                    />
                  </div>
                </div>
                <div className='field sublock'>
                  <label htmlFor='antmedAltsuenOtr'>
                    Especificar otros
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedAltsuenOtr'
                      type='text'
                      value={antmedAltsuenOtr}
                      onChange={(e) => setAntmedAltsuenOtr(e.target.value)}
                    />
                  </div>
                </div>

                <div
                  className='field key'
                  data-key={antmedAltapetRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha presentado o presenta alteraciones del apetito?
                    </label>
                    <label className='radio' htmlFor='antmedAltapetRadSi'>
                      <input
                        id='antmedAltapetRadSi'
                        name='antmedAltapetRad'
                        type='radio'
                        value='Si'
                        checked={antmedAltapetRad === "Si"}
                        onChange={(e) => setAntmedAltapetRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedAltapetRadNo'>
                      <input
                        id='antmedAltapetRadNo'
                        name='antmedAltapetRad'
                        type='radio'
                        value='No'
                        checked={antmedAltapetRad === "No"}
                        onChange={(e) => setAntmedAltapetRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antmedAltapetEsp'>
                    Especificar alteraciones del apetito
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedAltapetEsp'
                      type='text'
                      value={antmedAltapetEsp}
                      onChange={(e) => setAntmedAltapetEsp(e.target.value)}
                    />
                  </div>
                </div>

                <div
                  className='field key'
                  data-key={antmedAltsexRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha presentado o presenta alteraciones en su actividad
                      sexual?
                    </label>
                    <label className='radio' htmlFor='antmedAltsexRadSi'>
                      <input
                        id='antmedAltsexRadSi'
                        name='antmedAltsexRad'
                        type='radio'
                        value='Si'
                        checked={antmedAltsexRad === "Si"}
                        onChange={(e) => setAntmedAltsexRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedAltsexRadNo'>
                      <input
                        id='antmedAltsexRadNo'
                        name='antmedAltsexRad'
                        type='radio'
                        value='No'
                        checked={antmedAltsexRad === "No"}
                        onChange={(e) => setAntmedAltsexRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock' data-key={antmedAltsexEspKey}>
                  <label htmlFor='antmedAltsexEsp'>
                    Especificar alteraciones de la actividad sexual
                  </label>
                  <div className='control'>
                    <Select
                      isMulti
                      name='antmedAltsexEsp'
                      value={antmedAltsexEsp}
                      options={antmedAltsexEspOpt}
                      className='basic-multi-select'
                      classNamePrefix='select'
                      placeholder='Seleccionar enfermedad'
                      onChange={setAntmedAltsexEsp}
                    />
                  </div>
                </div>
                <div className='field sublock'>
                  <label htmlFor='antmedAltsexOtr'>
                    Especificar otros
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedAltsexOtr'
                      type='text'
                      value={antmedAltsexOtr}
                      onChange={(e) => setAntmedAltsexOtr(e.target.value)}
                    />
                  </div>
                </div>

                <div
                  className='field key'
                  data-key={antmedPatoculRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sufrido o sufre alguna patología ocular?
                    </label>
                    <label className='radio' htmlFor='antmedPatoculRadSi'>
                      <input
                        id='antmedPatoculRadSi'
                        name='antmedPatoculRad'
                        type='radio'
                        value='Si'
                        checked={antmedPatoculRad === "Si"}
                        onChange={(e) => setAntmedPatoculRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedPatoculRadNo'>
                      <input
                        id='antmedPatoculRadNo'
                        name='antmedPatoculRad'
                        type='radio'
                        value='No'
                        checked={antmedPatoculRad === "No"}
                        onChange={(e) => setAntmedPatoculRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock' data-key={antmedPatoculEspKey}>
                  <label htmlFor='antmedPatoculEsp'>
                    Especificar patología ocular
                  </label>
                  <div className='control'>
                    <Select
                      isMulti
                      name='antmedPatoculEsp'
                      value={antmedPatoculEsp}
                      options={antmedPatoculEspOpt}
                      className='basic-multi-select'
                      classNamePrefix='select'
                      placeholder='Seleccionar patología'
                      onChange={setAntmedPatoculEsp}
                    />
                  </div>
                </div>
                <div className='field sublock'>
                  <label htmlFor='antmedPatoculOtr'>
                    Especificar otros
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedPatoculOtr'
                      type='text'
                      value={antmedPatoculOtr}
                      onChange={(e) => setAntmedPatoculOtr(e.target.value)}
                    />
                  </div>
                </div>

                <div
                  className='field key'
                  data-key={antmedPatauditRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sufrido o sufre alguna patología auditiva?
                    </label>
                    <label className='radio' htmlFor='antmedPatauditRadSi'>
                      <input
                        id='antmedPatauditRadSi'
                        name='antmedPatauditRad'
                        type='radio'
                        value='Si'
                        checked={antmedPatauditRad === "Si"}
                        onChange={(e) => setAntmedPatauditRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedPatauditRadNo'>
                      <input
                        id='antmedPatauditRadNo'
                        name='antmedPatauditRad'
                        type='radio'
                        value='No'
                        checked={antmedPatauditRad === "No"}
                        onChange={(e) => setAntmedPatauditRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock' data-key={antmedPatauditEspKey}>
                  <label htmlFor='antmedPatauditEsp'>
                    Especificar patología auditiva
                  </label>
                  <div className='control'>
                    <Select
                      isMulti
                      name='antmedPatauditEsp'
                      value={antmedPatauditEsp}
                      options={antmedPatauditEspOpt}
                      className='basic-multi-select'
                      classNamePrefix='select'
                      placeholder='Seleccionar patología'
                      onChange={setAntmedPatauditEsp}
                    />
                  </div>
                </div>
                <div className='field sublock'>
                  <label htmlFor='antmedPatauditOtr'>
                    Especificar otros
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedPatauditOtr'
                      type='text'
                      value={antmedPatauditOtr}
                      onChange={(e) => setAntmedPatauditOtr(e.target.value)}
                    />
                  </div>
                </div>

                <div
                  className='field key'
                  data-key={antmedPatolfRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sufrido o sufre alguna patología olfativa?
                    </label>
                    <label className='radio' htmlFor='antmedPatolfRadSi'>
                      <input
                        id='antmedPatolfRadSi'
                        name='antmedPatolfRad'
                        type='radio'
                        value='Si'
                        checked={antmedPatolfRad === "Si"}
                        onChange={(e) => setAntmedPatolfRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedPatolfRadNo'>
                      <input
                        id='antmedPatolfRadNo'
                        name='antmedPatolfRad'
                        type='radio'
                        value='No'
                        checked={antmedPatolfRad === "No"}
                        onChange={(e) => setAntmedPatolfRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antmedPatolfEsp'>
                    Especificar patología olfativa
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedPatolfEsp'
                      type='text'
                      value={antmedPatolfEsp}
                      onChange={(e) => setAntmedPatolfEsp(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className='field'>
                <label className='' htmlFor='antmedObs'>
                  Observaciones
                </label>
                <div className='control'>
                  <textarea
                    className='textarea'
                    name='antmedObs'
                    id='antmedObs'
                    value={antmedObs}
                    onChange={(e) => setAntmedObs(e.target.value)}
                  ></textarea>
                </div>
              </div>
            </fieldset>
          </form>
        ))}
      </div>
      {!errorMessage &&
      <div id='actions'>
        {((diffDate <= 72 && props.userRole.includes('medicina')) || (props.userRole.includes('administrador')))  &&
        <button
          className='button is-link'
          id='saveButton'
          form='formUpdatelement'
          type='submit'
          disabled={isCreatingButton}
        >
          {isCreatingButton ? <div className="spinner"></div> : 'Guardar'}
        </button>
        }
        <Link
          className='button is-link is-light'
          to={`../${tratamientoId}/antecedentes/medicos/${antmedicos.id}`}
        >
          Cancelar
        </Link>
        {(props.userRole.includes('administrador'))  &&
        <button 
        className="button is-danger" 
        id="deleteButton" 
        onClick={deleteItem}
        disabled={isCreatingButton}
        >
        {isDeletingButton ? <div className="spinner"></div> : 'Eliminar'}
        </button>
        }
      </div>
      }
    </>
  );
}
